(() => {
  if (!customElements.get("slider-component-product")) {
    customElements.define(
      "slider-component-product",
      class SliderComponentProduct extends SliderComponent {
        constructor() {
          super();
          this.swiperEl = this.querySelector(".swiper");
          this.swiperContainer = this.querySelector(".swiper-wrapper");
          this.dotsContainer = this.querySelector(".slider-dots");
          this.mobileBreakpoint = 750;

          if (!this.swiperEl) return;

          this.initSwiper();
          this.handleResize = this.handleResize.bind(this);
          window.addEventListener("resize", this.handleResize);

          // After any modal closes, the gallery Swiper's internal pointerId can be
          // stuck non-null (due to a pointerout/pointerleave fired while the modal
          // was opening). Reset the touch state so new swipes are accepted.
          this._onModalClosed = () => {
            requestAnimationFrame(() => {
              if (!this.swiper || this.swiper.destroyed) return;
              const td = this.swiper.touchEventsData;
              if (!td) return;
              td.isTouched = false;
              td.isMoved = false;
              td.startMoving = false;
              td.pointerId = null;
              td.touchId = null;
              td.allowTouchCallbacks = false;
              this.swiper.allowTouchMove = true;
              this.swiper.params.allowTouchMove = true;
            });
          };
          document.body.addEventListener("modalClosed", this._onModalClosed);
        }

        initSwiper() {
          if (window.innerWidth >= this.mobileBreakpoint) {
            return; // Don't initialize on desktop
          }

          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }

          this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            loop: true,
            watchOverflow: true,
            allowTouchMove: true,
            pagination: {
              el: ".swiper-pagination",
              // dynamicBullets: true,
            },
            mousewheel: {
              invert: false,
            },
            on: {
              slideChange: (swiper) => {
                this.updateActiveDot(swiper);
              },
            },
          });

          // Re-initialize dots after swiper is created
          this.initDots();
        }

        handleResize() {
          const isMobile = window.innerWidth < this.mobileBreakpoint;

          if (isMobile && !this.swiper) {
            // Enable swiper on mobile
            this.initSwiper();
          } else if (!isMobile && this.swiper) {
            // Disable swiper on desktop
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
        }

        initDots() {
          if (!this.dotsContainer || !this.swiper) return;

          // Use event delegation to handle dot clicks
          // This avoids duplicate listeners and works even if dots are recreated
          if (!this.dotsClickHandler) {
            this.dotsClickHandler = (e) => {
              const dot = e.target.closest(".slider-dot");
              if (!dot || !this.swiper) return;

              const slideIndex = parseInt(
                dot.getAttribute("data-slide-index"),
                10
              );
              if (!isNaN(slideIndex)) {
                // Swiper with loop enabled uses realIndex for the actual slide position
                this.swiper.slideToLoop(slideIndex);
              }
            };
            this.dotsContainer.addEventListener("click", this.dotsClickHandler);
          }
        }

        updateActiveDot(swiper) {
          if (!this.dotsContainer || !swiper) return;

          const dots = this.dotsContainer.querySelectorAll(".slider-dot");
          const activeIndex = swiper.realIndex; // Use realIndex for loop mode

          dots.forEach((dot, index) => {
            if (index === activeIndex) {
              dot.classList.add("is-active");
              dot.setAttribute("aria-selected", "true");
            } else {
              dot.classList.remove("is-active");
              dot.setAttribute("aria-selected", "false");
            }
          });
        }

        disconnectedCallback() {
          if (this.handleResize) {
            window.removeEventListener("resize", this.handleResize);
          }
          if (this._onModalClosed) {
            document.body.removeEventListener("modalClosed", this._onModalClosed);
          }
          if (this.dotsContainer && this.dotsClickHandler) {
            this.dotsContainer.removeEventListener(
              "click",
              this.dotsClickHandler
            );
            this.dotsClickHandler = null;
          }
          if (this.swiper) {
            this.swiper.destroy(true, true);
          }
        }

        getSlidesPerView() {
          if (!this.colorSwatches.length) return;
          this.productCardRect = this.getBoundingClientRect();
          this.productCardWidth = this.productCardRect.width;
          this.colorSwatchWidth = this.colorSwatches[0].offsetWidth;

          if (!this.productCardWidth || !this.colorSwatchWidth) return;

          this.swatchGap = 10;
          this.slidesPerViewCount = Math.floor(
            this.productCardWidth / (this.colorSwatchWidth + this.swatchGap)
          );
          this.slidesPerView = this.slidesPerViewCount;
        }
      }
    );
  }
})();
